
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad/[id]",
      function () {
        return require("private-next-pages/ad/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad/[id]"])
      });
    }
  